var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('aside',{staticClass:"blog-sidebar"},[_c('blog-block-injector',{attrs:{"id":_vm.settings.sidebar_block}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }